export const POLICE_CLEARANCE_TYPES = [
  {
    group: "บริการในประเทศไทย (CID)",
    items: [
      "ใบรับรองความประพฤติ (CID) ภาษาไทย",
      "ใบรับรองความประพฤติ ภาษาอังกฤษ",
      "ตรวจประวัติพิมพ์ลายนิ้วมือ (10 นิ้ว)",
      "ตรวจประวัติด้วยบัตรประชาชน",
      "Police Clearance Certificate (ใช้ต่างประเทศ)",
      "ใบรับรองไม่มีคดีค้าง",
      "รับรองกงสุล MFA + สถานทูตปลายทาง",
      "ตรวจประวัติพนักงาน (Corporate / HR)",
    ],
  },
  {
    group: "บริการตรวจประวัติต่างประเทศ (สำหรับคนไทยในตปท. และตปท. ในไทย)",
    items: [
      "🇺🇸 FBI Background Check (USA)",
      "🇬🇧 DBS / ACRO Check (UK)",
      "🇦🇺 AFP Police Check (Australia)",
      "🇨🇦 RCMP Criminal Check (Canada)",
      "🇸🇬 Singapore CRC",
      "🇳🇿 Ministry of Justice (New Zealand)",
      "🇯🇵 Japan Police Clearance",
      "🇰🇷 Korea Criminal Investigation Record",
      "🇪🇺 European Criminal Record (EU)",
      "🇦🇪 UAE Good Conduct Certificate",
      "🇨🇳 China Notarial Certificate of No-Criminal",
      "ประเทศอื่นๆ ทั่วโลก (สอบถาม)",
    ],
  },
] as const;
